import React from 'react'

const CalendarCheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.66634 1.66797H4.99967V3.33496H4.16602C3.2458 3.33514 2.50018 4.08076 2.5 5.00098V16.668C2.5 17.5883 3.24569 18.3348 4.16602 18.335H7.5V16.668H4.16602V8.33464H15.833V10.835H17.5V5.00098C17.4998 4.08065 16.7534 3.33496 15.833 3.33496H14.9997V1.66797H13.333V3.33496H6.66634V1.66797ZM15.833 6.66797V5.00098H4.16602V6.66797H15.833Z'
				fill='currentColor'
			/>
			<path
				d='M9.16699 15.168L11.786 17.5013L14.6432 14.793L16.0718 13.4388L16.786 12.7617'
				stroke='currentColor'
				strokeWidth='1.66667'
				strokeLinejoin='round'
			/>
		</svg>
	)
}

export default CalendarCheckIcon
